import { useState } from "react";

function useDialogState() {
    const [loader, setLoader] = useState(false);

    const handleClickOpen = () => {
        setLoader(true);
    };

    const handleClose = () => {
        setLoader(false);
    };

    return {
        loader,
        handleClickOpen,
        handleClose,
    };
}

export default useDialogState;

export const Loader = () => {
    return (<>
        <div className="flex justify-center"><svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#fff"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            className="animate-spin h-5 w-5 mr-3 ..."
        >
            <path d="M21 12a9 9 0 11-6.219-8.56" />
        </svg></div></>)
}
export const LoaderBlack = () => {
    return (<>
        <div className="flex justify-center"><svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#000"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            className="animate-spin h-5 w-5 mr-3 ..."
        >
            <path d="M21 12a9 9 0 11-6.219-8.56" />
        </svg></div></>)
}
